export const ADMIN = "FlavorX Admin"
